function Screen(manager, container)
{
	this.manager = manager;
	this.container = container;
	this.outroAnimation = 'fadeOut 0.5s';
	this.name = null;
}

Screen.NAMED_SPRITE_PREFIX = '_';
Screen.OUT_INDEX = 20;
Screen.IN_INDEX = 10;

Screen.prototype = 
{
	register: function(screenName)
	{
		this.manager.screens[ screenName ] = this;
		this.name = screenName;
	},
	store: function()
	{
		this.storedChildren = this.view.html();
	},
	restore: function(ScreenView, container, $scope)
	{
		var screen = this;

		angular.element('body').injector().invoke(function($compile, $rootScope) 
		{
			var compiled = $compile( screen.storedChildren )( $scope );

			screen.view.empty();
			screen.view.append( compiled );

			$scope.$apply();

			ScreenView.build( screen.view );

			screen.view.find('*').scale( container.getScale() );

			screen.loadSprites();
		});
	},
	bind: function(view)
	{
		this.view = view;
		this.loadSprites();
		this.trigger('bind');
	},
	loadSprites: function()
	{
		this.sprites = this.view.find('*');
		this.importNamedSprites( this, Screen.NAMED_SPRITE_PREFIX );
	},
	importNamedSprites: function(into, prefix)
	{
		this.sprites.filter('[data-named]').each(function()
		{
			var e = $(this);
			var nm = e.data('named');
			
			if ( nm )
			{
				into[ prefix + nm ] = e;
			}	
		});
	},
	sprite: function(named)
	{
		return this[ Screen.NAMED_SPRITE_PREFIX + named ];
	},
	introduce: function(spriteName, animation)
	{
		var sprite = this.sprite( spriteName );
		
		sprite
			.removeClass('hidden')
			.play( animation )
			.applyInitialState()
			.animators()
			.once('finished', function()
			{
				sprite.restore();
			})
		;
	},
	introduceMany: function(sprites, animation)
	{
		sprites
			.removeClass('hidden')
			.play( animation )
			.applyInitialState()
			.animators()
			.once('finished', function()
			{
				this.restore();
			})
		;
	},
	outroduce: function(spriteName, animation, callback)
	{
		this.outroduceMany( this.sprite( spriteName ), animation, callback );
	},
	outroduceMany: function(sprites, animation, callback)
	{
		sprites.each(function()
		{
			var sprite = $(this);
			
			if ( sprite.hasClass( 'hidden' ) )
			{
				return;
			}

			sprite
				.play( animation )
				.animators()
				.once( 'finished', function() 
				{
					sprite.addClass('hidden');
					
					if ( anim8.isFunction( callback ) )
					{
						callback.call( sprite, sprite );
					}
				})
			;
		});
	},
	flash: function(spriteName, show, hide)
	{
		var sprite = this.sprite( spriteName );

		sprite
			.removeClass( 'hidden' )
			.play( show )
			.applyInitialState()
			.animators()
			.once( 'finished', function()
			{
				sprite
					.play( hide )
					.applyInitialState()
					.animators()
					.once( 'finished', function()
					{
						sprite.addClass( 'hidden' );
					})
				;
			})
		;
	},
	outro: function()
	{	
		this.trigger('outroBefore');

		anim8.animating.stop();	
		
		this.trigger('outroBegin');
		
		this.sprites
			.not('.hidden')
			.dataPlay('outro')
			.applyInitialState()
		;
		
		if (anim8.running)
		{
			anim8.once('finished', this.outroEnd, this);	
		}
		else
		{
			this.outroEnd();
		}
	},
	outroEnd: function()
	{
		this.trigger('outroEnd');
		
		this.view
			.css( 'zIndex', Screen.OUT_INDEX )
			.play( this.outroAnimation )
			.applyInitialState()
			.animators()
			.once('finished', this.outroFinished, this)
		;
	},
	outroFinished: function()
	{
		this.view
			.hide()
			.restore()
		;
				
		this.sprites
			.stopIt()
			.restore()
		;
	},
	intro: function()
	{
		this.loadSprites();
		
		this.trigger('introBefore');

		this.sprites
			.filter('.hidden-after-intro')
			.removeClass('hidden')
		;
		
		this.sprites
			.scale( this.container.getScale() )
			.filter('[data-intro]')
			.not('.hidden')
			.hide()
		;
		
		this.view
			.css( 'zIndex', Screen.IN_INDEX )
			.show()
		;
		
		if (anim8.running)
		{
			anim8.once('finished', this.introBegin, this);	
		}
		else
		{
			this.introBegin();
		}
	},
	introBegin: function()
	{
		this.trigger('introBegin');
		
		this.sprites
			.not('.hidden')
			.show()
			.dataPlay('intro')
			.applyInitialState()
		;

		this.sprites
			.filter('.hidden-after-intro')
			.animators()
			.once('finished', function()
			{
				$( this.e ).addClass('hidden');
			})
		;
		
		if (anim8.running)
		{
			anim8.once('finished', this.introEnd, this);
		}
		else
		{
			this.introEnd();
		}
	},
	introEnd: function()
	{
		this.trigger('introEnd');
		
		this.sprites
			.dataQueue('emphasis')
		;
	}
};

anim8.eventize( Screen.prototype );